import { v4 as uuidv4 } from 'uuid';

/**
 * The durable per-browser id used as the `LD-Session` header, as a LaunchDarkly
 * context attribute, and as the `ld_session_id` Mixpanel super-prop.
 *
 * Lives in localStorage, independently of Mixpanel's cookie-backed $device_id —
 * which is why the two diverge over time and why experiment flags bucket on the
 * device id rather than on this.
 *
 * Read at module scope by main.jsx (the LaunchDarkly provider's initial context
 * is built before React renders), so it cannot live inside a component.
 */
export const getOrSetDiffitSessionId = () => {
  let sessionId = localStorage.getItem('diffitSessionId');
  if (!sessionId) {
    sessionId = uuidv4();
    localStorage.setItem('diffitSessionId', sessionId);
  }
  return sessionId;
};
